import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { PrivateLayoutComponent } from '@app/main/layout/private/private-layout.component';
import { PublicLayoutComponent } from '@app/main/layout/public/public-layout.component';
import { SharedModule } from '@app/shared';
import { CoreModule } from '@app/core';
import { AuthModule } from '@app/modules/auth';
import { UserModule } from '@app/modules/user';
import { NotificationsModule } from '@app/modules/notifications';
import { NotFoundPageComponent } from '@app/main/page/not-found/not-found.component';
import { PublicPatientInfoPageComponent } from '@app/main/page/public-patient-info/public-patient-info.component';
import { PublicMolstLookupComponent } from '@app/main/page/public-molst-lookup/public-molst-lookup.component';
import { PublicDirectiveVerifyComponent } from '@app/main/page/public-directive-verify/public-directive-verify.component';
import { DeviceEnrollComponent } from '@app/main/page/device-enroll/device-enroll.component';
import { PatientSidebarComponent } from '@app/main/part/patient-sidebar/patient-sidebar.component';
import { AdminSidebarComponent } from '@app/main/part/admin-sidebar/admin-sidebar.component';
import { DoctorSidebarComponent } from '@app/main/part/doctor-sidebar/doctor-sidebar.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '@app/modules/auth/service/auth.interceptor';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

const imports = [
  BrowserModule,
  BrowserAnimationsModule,
  AppRoutingModule,
  CoreModule,
  AuthModule,
  UserModule,
  NotificationsModule,
  SharedModule,
];

const declarations = [
  AppComponent,
  PrivateLayoutComponent,
  PublicLayoutComponent,
  NotFoundPageComponent,
  PublicPatientInfoPageComponent,
  PublicMolstLookupComponent,
  PublicDirectiveVerifyComponent,
  DeviceEnrollComponent,
  PatientSidebarComponent,
  AdminSidebarComponent,
  DoctorSidebarComponent,
];

@NgModule({
  imports,
  declarations,
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {}
